module.exports = __webpack_public_path__ + "img/voucher_details.1f8f71f5.svg";